import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import PeriodAndEmployeeSelector from 'modules/billing/components/FactorialF25Bundles/_Summary/_PeriodAndEmployeeSelector'
import * as styles from 'modules/billing/components/FactorialF25Bundles/index.vanilla.css'
import PriceDetail from 'modules/billing/components/PriceDetail'
import { formatPrice } from 'modules/billing/lib/f25Prices'
import { useF25PricingContext } from 'modules/onboarding/components/Pricing/F25PricingContext'
import { DEFAULT_CURRENCY } from 'modules/onboarding/lib/pricing/plans/utils'

import OrderSummary from './_OrderSummary'

const SummaryCard = () => {
  const {
    allPlans,
    getSubscriptionItems,
    isSelfServedSegment,
    computeTotalPrice,
    isYearly,
    country,
  } = useF25PricingContext()
  const currency = allPlans.f25Plans[0]?.pricing?.currency || DEFAULT_CURRENCY
  const totalPrice = computeTotalPrice()

  const EXCLUDED_COUNTRIES = ['br']

  const excludedCountries = EXCLUDED_COUNTRIES.includes(country)

  const commonProps = {
    bundleSubscriptionItems: getSubscriptionItems(),
    disableButton: false,
  }

  return (
    <Box
      border={{
        all: {
          width: 's1',
          style: 'solid',
          color: 'grey400',
        },
      }}
      borderRadius={{ all: 'abs008' }}
      gap="s24"
      width="full"
    >
      <Box>
        <Box padding="s24" paddingBottom="s0">
          <Box alignItems="center" flexDirection="row" justifyContent="spaceBetween">
            <Text size="400" color="grey1000" weight="medium">
              {i18n.t('pricing_plans.total_amount')}
            </Text>
          </Box>
          <Box gap="s4" paddingTop="s16">
            <Text.Header1
              weight="semibold"
              className={isSelfServedSegment && !excludedCountries ? '' : styles.blurredText}
            >
              {formatPrice(totalPrice, currency)}
            </Text.Header1>
            {isYearly() ? (
              <Text size="300" color="grey800">
                {i18n.t('pricing_plans.price_year', { currency })}
              </Text>
            ) : (
              <Text size="300" color="grey800">
                {i18n.t('pricing_plans.price_month', { currency })}
              </Text>
            )}
          </Box>
        </Box>
        <PeriodAndEmployeeSelector />
        <PriceDetail.F25Trial
          {...commonProps}
          showContactSalesButton={!isSelfServedSegment || excludedCountries}
        >
          <Box gap="s24" paddingTop="s0">
            <OrderSummary currency={currency} />
          </Box>
        </PriceDetail.F25Trial>
      </Box>
    </Box>
  )
}

export default SummaryCard
